'use client'

import { ConversationMessageType } from '@marketplace-web/domain/conversation-messaging-data'
import { OfferMessage } from '@marketplace-web/domain/price-offers-data'

import { useConversationContext } from '@marketplace-web/domain/core-conversation'

import { isOfferMessage } from '../utils/price-offers'

const useGetPendingSellerOfferMessage = (): OfferMessage | null => {
  const { conversation } = useConversationContext()

  const pendingSellerOfferMessage = conversation?.messages?.find(
    message =>
      isOfferMessage(message.message) &&
      message.message.isCurrentOffer &&
      message.entityType === ConversationMessageType.OfferMessage,
  )?.message

  return pendingSellerOfferMessage && isOfferMessage(pendingSellerOfferMessage)
    ? pendingSellerOfferMessage
    : null
}

export default useGetPendingSellerOfferMessage
